import React, { useCallback, useContext, useEffect, useState } from 'react'
import { CostList } from '../components/CostList'
import { Loader } from '../components/Loader'
import { AuthContext } from '../context/AuthContext'
import { CardContext } from '../context/CardContext'
import { useHttp } from '../hooks/http.hook'

export const CostPage = () => {
    const auth = useContext(AuthContext);
    const card = useContext(CardContext)
    const [fetchedCards, setFetchedCards] = useState([])
    const [cards, setCards] = useState([])
    const {loading, request} = useHttp()
    const {token} = useContext(AuthContext)
    const [filters, setFilters] = useState("");

    const SetFilteredCards = () => {
        // const cardsFilter = new RegExp(filters, 'gi')
        if (filters.length < 3){
            alert('Запрос должен содержать минимум 3 символа')
        }
        else{
            const cardsFilter = filters.toLocaleLowerCase()
        let newCards = []
        newCards = fetchedCards.filter(elem => {
            if (elem.date.toLocaleLowerCase().includes(cardsFilter) || elem.totalPrice.toLocaleLowerCase().includes(cardsFilter) || elem.formData.clientType?.fio.toLocaleLowerCase().includes(cardsFilter) || elem.formData.clientType?.name.toLocaleLowerCase().includes(cardsFilter) || elem.formData.clientType?.ofp.toLocaleLowerCase().includes(cardsFilter) || elem.formData.clientType?.shortofp.toLocaleLowerCase().includes(cardsFilter)  || elem?.formedId?.toLocaleLowerCase().includes(cardsFilter) || elem?.paymentUsluga?.toLocaleLowerCase().includes(cardsFilter) || elem?.paymentDate?.toLocaleLowerCase().includes(cardsFilter) || elem?.urist?.toLocaleLowerCase().includes(cardsFilter)){
                return true
            }
            return false
        })
        setCards(newCards)
        }
    }

    const DeleteCard = async (_id, paymentUsluga,paymentDate,paymentPayed, index) => {
        try {
            const data = await request('/api/card/payment', 'POST', {_id, paymentDate, paymentUsluga, paymentPayed, paymentDeleted: true}, {
                Authorization: `Bearer ${auth.token}`
            })
            // alert(data.message)
            const newCards = cards.filter((elem, ind) => ind !== index)
            setCards(newCards)
            // fetchCards()
        } catch (e) {
        }
    }

//     const SaveCard = async (form) => {
//         try {
//             delete form._id
//             const data = await request('/api/card/generate', 'POST', {form:{...form, formed: false, formedId:'', _id:null}}, {
//                 Authorization: `Bearer ${auth.token}`
//             })
//             alert(data.message)
//             fetchCards()
//         } catch (e) {
//         }
//   };
const SaveCard = async (_id, paymentUsluga,paymentDate,paymentPayed ) => {
    try {
        const data = await request('/api/card/payment', 'POST', {_id, paymentDate, paymentUsluga, paymentPayed}, {
            Authorization: `Bearer ${auth.token}`
        })
        alert(data.message)
        // fetchCards()
    } catch (e) {
    }
};

    const CardEdit = (form) => {
        card.createForm(form)
    }

    const fetchCards = useCallback(async()=>{
        try {
            const fetched = await request('/api/card/schets', 'GET', null, {
                Authorization: `Bearer ${token}`
            })
            let fetchCards = fetched?.reverse()
            setFetchedCards(fetchCards)
            setCards(fetchCards)
        } catch (e) {
            
        }
    },[token, request])

    useEffect(()=>{
        fetchCards()
        
    },[fetchCards])

    if (loading){
        return <Loader/>
    }
    return (
        <div>
            <div className="row">
        <div className="input-field col s9">
          <input
            value={filters}
            onChange={(e) => setFilters(e.target.value)}
            placeholder={"Поиск по счетам"}
            id={"search"}
            type={"search"}
          />
        </div>
        <div style={{ paddingTop: "2%" }} className="col s1">
          <a
            className="waves-effect waves-light btn-small"
            onClick={SetFilteredCards}
          >
            Найти
          </a>
          
        </div>
        <div style={{ paddingTop: "2%" }} className="col s2">
            <a  className="waves-effect waves-light btn-small" onClick={fetchCards}>Показать все</a>
        </div>
        
      </div>
            {!loading && <CostList DeleteCard={DeleteCard} SaveCard={SaveCard} CardEdit={CardEdit} cards={[...cards]}/>}
            {/* <div style={{paddingTop:"1%"}} className="center">
                <a  className="waves-effect waves-light btn-small" onClick={fetchCards}>Обновить</a>
            </div> */}
            
        </div>
    )
}